var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "utxo_label"
  }, [_vm._v(_vm._s(_vm._f("fromOrTo")(_vm.type)))]), _vm._l(_vm.addresses, function (_ref, i) {
    var address = _ref.address,
        displayAddress = _ref.displayAddress;
    return _c('div', {
      key: i
    }, [_vm.isXP(displayAddress) ? _c('router-link', {
      staticClass: "address monospace compound_interest",
      attrs: {
        "to": _vm.xpURL(address)
      }
    }, [_vm._v(_vm._s(displayAddress))]) : _c('a', {
      staticClass: "address monospace compound_interest",
      attrs: {
        "href": "".concat(_vm.cURL(address))
      }
    }, [_vm._v(_vm._s(displayAddress) + " ")])], 1);
  }), _c('div')], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }